<div style="width: 100%; height: 100%; display: flex; flex-direction: column; overflow: hidden">
  <list-view
    #listView
    [delegate]="this"
    style="width: 100%; height: 100%; display: flex; flex-direction: column"
  >
    <list-search-box style="margin-top: 10px">
      <items-search-box
        [searchCriteria]="listView.searchCriteria"
        (searchCriteriaChanged)="listView.searchCriteriaChanged($event)"
      >
      </items-search-box>
      <div style="padding-top: 2px; position: absolute">
        <button
          title="Export List"
          type="button"
          (click)="exportList()"
          class="btn btn-outline-secondary pull-left"
        >
          <mat-icon>file_download</mat-icon>
        </button>
      </div>
    </list-search-box>
    <list-render-items
      style="height: 100%; width: 100%; display: flex; flex-direction: column; margin-top: 10px"
    >
      <div class="ng-star-inserted" style="height: 100%">
        <ag-grid-angular
          #agGrid
          id="agGrid"
          [editType]="editType"
          class="ag-theme-balham"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          (firstDataRendered)="onFirstDataRendered()"
          [components]="components"
          [rowSelection]="'multiple'"
          [rowMultiSelectWithClick]="true"
          (gridReady)="onGridReady($event)"
          [components]="frameworkComponents"
          [rowData]="listView.items"
          (rowValueChanged)="onRowValueChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          [enableCellChangeFlash]="true"
          [animateRows]="true"
        >
        </ag-grid-angular>
      </div>
    </list-render-items>
  </list-view>
</div>
